import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import {
  Autocomplete,
  Avatar,
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import axios from 'axios';

const supportOptions = [
  'Can refer in my company',
  'Can hire directly talent from community',
  'Can educate or mentor people looking for job',
  'Can get you connected with a Leader for further help',
  'Can train & hire college graduates',
  'Can help mentoring for new business',
  'Can help mentoring young talents for their future career',
  'Currently not in a position to help',
];

const supporterOptions = [
  'Are you an IT leader?',
  'Are you an SME?',
  'Are you a business owner?',
];

const cardSx = {
  p: { xs: 2, md: 2.5 },
  borderRadius: 3,
  border: '1px solid #e2e8f0',
  boxShadow: 'none',
  bgcolor: '#ffffff',
};

const ProfileUpdate = () => {
  const { setProfileUpdated } = useContext(AuthContext);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [activeStep, setActiveStep] = useState(0);
  const navigate = useNavigate();
  const [form, setForm] = useState({
    intent: '',
    firstName: '',
    lastName: '',
    profilePhoto: '',
    industry: '',
    company: '',
    role: '',
    mobile: '',
    anonymousPhoto: false,
    anonymousMobile: false,
    isprovider: false,
    helpfields: [],
    supporter_lst: [],
    other_help: '',
    other_support: '',
    localcommunity: '',
  });
  const [preview, setPreview] = useState('');
  const [options, setOptions] = useState({
    industries: [],
    companies: [],
    roles: [],
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');

    if (token) {
      axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/api/profile/get`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          const data = res.data;
          setForm({
            intent: data.intent || '',
            other_help: data.other_help || '',
            other_support: data.other_support || '',
            localcommunity: data.localcommunity || '',
            firstName: data.first_name || '',
            lastName: data.last_name || '',
            profilePhoto: data.profile_photo || '',
            industry: data.industry || '',
            company: data.company || '',
            role: data.role || '',
            mobile: data.mobile || '',
            anonymousPhoto: !!data.anonymous_photo,
            anonymousMobile: !!data.anonymous_mobile,
            isprovider: !!data.isprovider,
            helpfields: Array.isArray(data.helpfields)
              ? data.helpfields
              : data.helpfields
                ? JSON.parse(data.helpfields)
                : [],
            supporter_lst: Array.isArray(data.supporter_lst)
              ? data.supporter_lst
              : data.supporter_lst
                ? JSON.parse(data.supporter_lst)
                : [],
          });
          setPreview(data.profile_photo || '');
        })
        .catch((err) => console.error('Error fetching profile:', err));
    }

    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/profile/options`)
      .then((res) => setOptions(res.data))
      .catch((err) => console.error('Error fetching options:', err));
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => {
      setForm((prev) => ({ ...prev, profilePhoto: reader.result }));
      setPreview(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSaving(true);
    const token = localStorage.getItem('token');
    axios
      .post(`${process.env.REACT_APP_API_BASE_URL}/api/profile/update`, form, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(() => {
        alert('Profile updated successfully');
        setProfileUpdated(true);
        navigate('/2.0/udyogconnect-home');
      })
      .catch((err) => {
        console.error('Error updating profile:', err);
        alert('Failed to update profile');
      })
      .finally(() => setSaving(false));
  };

  const toggleListValue = (field, option) => {
    setForm((prev) => {
      const exists = prev[field].includes(option);
      return {
        ...prev,
        [field]: exists
          ? prev[field].filter((item) => item !== option)
          : [...prev[field], option],
      };
    });
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        mx: { xs: -3.75, md: -3.75 },
        my: { xs: -3.75, md: -3.75 },
        px: { xs: 2, md: 4 },
        py: { xs: 3, md: 5 },
        background:
          'radial-gradient(circle at 12% 10%, rgba(15,118,110,0.10), transparent 28%), radial-gradient(circle at 92% 6%, rgba(37,99,235,0.10), transparent 30%), linear-gradient(180deg, #f8fafc 0%, #eef4f8 100%)',
      }}
    >
      <Box sx={{ maxWidth: 1180, mx: 'auto' }}>
        <Box
          sx={{
            mb: 3,
            display: 'flex',
            justifyContent: 'space-between',
            gap: 2,
            alignItems: { xs: 'flex-start', md: 'flex-end' },
            flexDirection: { xs: 'column', md: 'row' },
          }}
        >
          <Box>
            <Typography
              component="span"
              sx={{
                display: 'inline-flex',
                px: 1.5,
                py: 0.75,
                mb: 1.5,
                borderRadius: 999,
                bgcolor: '#ecfdf5',
                color: '#0f766e',
                fontSize: 12,
                fontWeight: 800,
                textTransform: 'uppercase',
              }}
            >
              Udyog Connect Profile
            </Typography>
            <Typography variant="h3" fontWeight={900} sx={{ color: '#0f172a', fontSize: { xs: 30, md: 44 }, lineHeight: 1.1 }}>
              Complete Your Profile
            </Typography>
            <Typography sx={{ mt: 1, color: '#64748b', maxWidth: 760, lineHeight: 1.7 }}>
              Help the community understand who you are, what support you need, and how you can contribute.
            </Typography>
          </Box>

          {isMobile && (
            <Box sx={{ display: 'flex', gap: 1, width: '100%' }}>
              {['Intent', 'Profile'].map((label, index) => (
                <Box
                  key={label}
                  sx={{
                    flex: 1,
                    p: 1,
                    borderRadius: 2,
                    textAlign: 'center',
                    fontSize: 13,
                    fontWeight: 800,
                    bgcolor: activeStep === index ? '#0f766e' : '#ffffff',
                    color: activeStep === index ? '#ffffff' : '#64748b',
                    boxShadow: '0 8px 22px rgba(15,23,42,0.07)',
                  }}
                >
                  {label}
                </Box>
              ))}
            </Box>
          )}
        </Box>

        <Paper elevation={0} sx={{ p: { xs: 2, md: 3 }, borderRadius: 4, bgcolor: 'rgba(255,255,255,0.92)', boxShadow: '0 18px 45px rgba(15,23,42,0.08)' }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4} sx={{ display: isMobile && activeStep !== 0 ? 'none' : 'block' }}>
              <Paper elevation={0} sx={{ ...cardSx, height: '100%' }}>
                <Typography variant="h6" sx={{ fontWeight: 800, color: '#0f172a' }}>
                  Select Your Intent
                </Typography>
                <Typography variant="body2" sx={{ color: '#64748b', mt: 0.5, mb: 2 }}>
                  Tell us whether you are here to support others or seek support.
                </Typography>

                <FormControl fullWidth margin="normal">
                  <InputLabel id="intent-label">Intent</InputLabel>
                  <Select
                    labelId="intent-label"
                    label="Intent"
                    value={form.intent}
                    onChange={(e) => setForm((prev) => ({ ...prev, intent: e.target.value }))}
                  >
                    <MenuItem value="help">I want to help</MenuItem>
                    <MenuItem value="need">I need help</MenuItem>
                  </Select>
                </FormControl>

                {!form.intent && (
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                    Please select an intent to continue.
                  </Typography>
                )}

                {form.intent === 'help' && (
                  <Box sx={{ mt: 2 }}>
                    <Typography variant="body1" sx={{ mb: 1, fontWeight: 700 }}>
                      Great. We can add you as a community supporter in just a few minutes.
                    </Typography>
                    <FormGroup>
                      {supporterOptions.map((option) => (
                        <FormControlLabel
                          key={option}
                          control={
                            <Checkbox
                              checked={form.supporter_lst.includes(option)}
                              onChange={() => toggleListValue('supporter_lst', option)}
                            />
                          }
                          label={option}
                        />
                      ))}
                      <TextField
                        fullWidth
                        label="Other support identity"
                        value={form.other_support}
                        onChange={(e) => setForm((prev) => ({ ...prev, other_support: e.target.value }))}
                        margin="dense"
                      />
                    </FormGroup>

                    <Typography variant="subtitle1" sx={{ mt: 2, fontWeight: 800 }}>
                      Areas you want to support
                    </Typography>
                    <FormGroup>
                      {supportOptions.map((option) => (
                        <FormControlLabel
                          key={option}
                          control={
                            <Checkbox
                              checked={form.helpfields.includes(option)}
                              onChange={() => toggleListValue('helpfields', option)}
                            />
                          }
                          label={option}
                        />
                      ))}
                      <TextField
                        fullWidth
                        label="Other support area"
                        value={form.other_help}
                        onChange={(e) => setForm((prev) => ({ ...prev, other_help: e.target.value }))}
                        margin="dense"
                      />
                    </FormGroup>
                  </Box>
                )}

                {form.intent === 'need' && (
                  <Box sx={{ mt: 2 }}>
                    <Typography variant="body1" sx={{ mb: 1, fontWeight: 700 }}>
                      We will help you get started by understanding what support you need.
                    </Typography>
                    <TextField
                      fullWidth
                      multiline
                      label="What help do you need?"
                      value={form.other_help}
                      onChange={(e) => setForm((prev) => ({ ...prev, other_help: e.target.value }))}
                      margin="normal"
                      rows={4}
                    />
                  </Box>
                )}

                {form.intent && (
                  <TextField
                    fullWidth
                    label="Are you a member of any local community?"
                    value={form.localcommunity}
                    onChange={(e) => setForm((prev) => ({ ...prev, localcommunity: e.target.value }))}
                    margin="normal"
                  />
                )}

                {isMobile && activeStep === 0 && (
                  <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                    <Button variant="contained" onClick={() => setActiveStep(1)} sx={{ borderRadius: 999, bgcolor: '#0f766e' }}>
                      Next
                    </Button>
                  </Box>
                )}
              </Paper>
            </Grid>

            <Grid item xs={12} md={8} sx={{ display: isMobile && activeStep !== 1 ? 'none' : 'block' }}>
              <Paper elevation={0} sx={cardSx}>
                <Typography variant="h6" sx={{ fontWeight: 800, color: '#0f172a' }}>
                  Basic Profile Information
                </Typography>
                <Typography variant="body2" sx={{ color: '#64748b', mt: 0.5, mb: 2 }}>
                  Keep this accurate so members and admins can understand your background.
                </Typography>

                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 2, flexWrap: 'wrap' }}>
                  <Avatar src={preview} alt="Profile Preview" sx={{ width: 88, height: 88, boxShadow: '0 10px 25px rgba(15,23,42,0.12)' }} />
                  <Button variant="contained" component="label" sx={{ borderRadius: 999, bgcolor: '#111827' }}>
                    Upload Photo
                    <input type="file" hidden accept="image/*" onChange={handleImageUpload} />
                  </Button>
                </Box>

                <FormControlLabel
                  control={<Checkbox checked={form.anonymousPhoto} onChange={handleChange} name="anonymousPhoto" />}
                  label="Make my photo anonymous"
                />

                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextField fullWidth label="First Name" name="firstName" value={form.firstName} onChange={handleChange} margin="normal" />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField fullWidth label="Last Name" name="lastName" value={form.lastName} onChange={handleChange} margin="normal" />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField fullWidth label="Mobile Number" name="mobile" value={form.mobile} onChange={handleChange} margin="normal" />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Box sx={{ mt: 2 }}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>Are you a Provider?</Typography>
                      <RadioGroup
                        row
                        name="isprovider"
                        value={form.isprovider ? 'yes' : 'no'}
                        onChange={(e) => setForm((prev) => ({ ...prev, isprovider: e.target.value === 'yes' }))}
                      >
                        <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                        <FormControlLabel value="no" control={<Radio />} label="No" />
                      </RadioGroup>
                    </Box>
                  </Grid>
                </Grid>

                <FormControlLabel
                  control={<Checkbox checked={form.anonymousMobile} onChange={handleChange} name="anonymousMobile" />}
                  label="Make my mobile number anonymous"
                />

                <Autocomplete
                  freeSolo
                  fullWidth
                  options={options.industries}
                  value={form.industry}
                  onChange={(e, newVal) => setForm((prev) => ({ ...prev, industry: newVal || '' }))}
                  onInputChange={(e, newInputValue) => setForm((prev) => ({ ...prev, industry: newInputValue }))}
                  renderInput={(params) => <TextField {...params} label="Industry" margin="normal" />}
                />
                <Autocomplete
                  freeSolo
                  fullWidth
                  options={options.companies}
                  value={form.company}
                  onChange={(e, newVal) => setForm((prev) => ({ ...prev, company: newVal || '' }))}
                  onInputChange={(e, newInputValue) => setForm((prev) => ({ ...prev, company: newInputValue }))}
                  renderInput={(params) => <TextField {...params} label="Company" margin="normal" />}
                />
                <Autocomplete
                  freeSolo
                  fullWidth
                  options={options.roles}
                  value={form.role}
                  onChange={(e, newVal) => setForm((prev) => ({ ...prev, role: newVal || '' }))}
                  onInputChange={(e, newInputValue) => setForm((prev) => ({ ...prev, role: newInputValue }))}
                  renderInput={(params) => <TextField {...params} label="Role" margin="normal" />}
                />

                {isMobile && (
                  <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', gap: 2 }}>
                    <Button onClick={() => setActiveStep(0)} variant="outlined" sx={{ borderRadius: 999 }}>Back</Button>
                    <Button variant="contained" onClick={handleSubmit} disabled={saving} sx={{ borderRadius: 999, bgcolor: '#0f766e' }}>
                      {saving ? 'Saving...' : 'Save Profile'}
                    </Button>
                  </Box>
                )}
              </Paper>
            </Grid>

            {!isMobile && (
              <Grid item xs={12}>
                <Box sx={{ textAlign: 'center', mt: 1 }}>
                  <Button
                    variant="contained"
                    size="large"
                    onClick={handleSubmit}
                    disabled={saving}
                    sx={{ borderRadius: 999, px: 5, py: 1.3, bgcolor: '#0f766e', fontWeight: 800 }}
                  >
                    {saving ? 'Saving...' : 'Save Profile'}
                  </Button>
                </Box>
              </Grid>
            )}
          </Grid>
        </Paper>
      </Box>
    </Box>
  );
};

export default ProfileUpdate;
